import React, { useEffect } from 'react';
import Information from './components/Information';
import AdditionalInformation from './components/AdditionalInformation';
import { Button, Col, Form, message, Row } from 'antd';
import { useHistory, useParams } from 'react-router-dom';
import * as CommonService from '../../../services/CommonService';
import { CUSTOMER_ENDPOINT } from '../../../services/endpoint';
import moment from 'moment';

const CustomerCreate = (props) => {

  const { id } = useParams();

  const history = useHistory();

  useEffect(() => {
    const init = async () => {
      try {
        window.setLoading(true);
        const resp = await CommonService.findById(CUSTOMER_ENDPOINT, id);
        const data = resp?.data || {};
        props.form.setFieldsValue({ ...data, dob: moment(data.dob), gender: data.gender?.toString() || '0' });
      } catch (error) {
        message.error(error?.data?.message);
      } finally {
        window.setLoading(false);
      }
    };
    init();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    props.form.validateFields((err, values) => {
      if (!err) {
        const body = {
          ...values,
          debt: {
            amount: values.totalDebt
          }
        };
        delete body.totalDebt;
        delete body.customerCode;
        window.setLoading(true);
        CommonService.update(CUSTOMER_ENDPOINT, id, body).then(res => {
          message.success('Cập nhật thành công');
          back();
        }).catch(err => {
          message.error(err?.data?.message);
        })
          .finally(() => {
            window.setLoading(false);
          });
      }
    });
  };

  const back = () => {
    history.push('/customer/' + id);
  };

  return (
    <div id={'product-create-page'}>
      <Form layout={'vertical'}>
        <Row gutter={12}>
          <Row>
            <Col>
              <Information form={props.form}
              />
            </Col>
            <Col>
              <AdditionalInformation form={props.form}
              />
            </Col>
          </Row>
        </Row>
        <div className={'btn-group mt-20'}>
          <Button type={'ghost'} onClick={back}>Thoát</Button>
          <Button type={'primary'} onClick={handleSubmit}>Cập nhật khách hàng</Button>
        </div>
      </Form>
    </div>
  );
};

export default Form.create({ name: 'CustomerCreate' })(CustomerCreate);

